import { createRouter, createWebHistory } from 'vue-router'

const routes = [
  {
    path: '/performance-resource-kit/s7gd634ghfdw6c/tools/me/retail-value-calculator/mesz',
    name: 'mesz',
    component: () => import('../components/MeszView.vue')
  },
  {
    path: '/performance-resource-kit/s7gd634ghfdw6c/tools/me/retail-value-calculator/mes10',
    name: 'mes10',
    component: () => import('../components/Mes10View.vue')
  },
  {
    path: '/performance-resource-kit/s7gd634ghfdw6c/tools/me/retail-value-calculator/mes15',
    name: 'mes15',
    component: () => import('../components/Mes15View.vue')
  },
  {
    path: '/resource-library/microessentials-roi-calculator',
    name: 'micro',
    component: () => import('../components/MicroCalculator.vue')
  },
  {
    path: '/resource-library/aspire-roi-calculator',
    name: 'aspire',
    component: () => import('../components/AspireCalculator.vue')
  },
  {
    path: '/dealer-locator',
    name: 'locator',
    component: () => import('../components/LocatorWrapper.vue')
  },
  {
    path: '/resource-library/nutrient-removal-calculator',
    name: 'nutrient',
    component: () => import('../components/NutrientRemoval.vue')
  },
  {
    path: '/29t82dzqrf9bpn/cam/acn/mosaic-crop-nutrition/microessentials/mighty-micro/pf7',
    name: 'microCampaign',
    component: () => import('../components/CampaignMicroCalculator.vue')
  },
  {
    path: '/29t82dzqrf9bpn/cam/acn/mosaic-crop-nutrition/microessentials/mighty-micro/nutrient-removal-calc',
    name: 'nutrientCampaign',
    component: () => import('../components/NutrientRemoval.vue')
  }
]

const router = createRouter({
  history: createWebHistory(),
  routes
})

export default router
